import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import { useMemo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { memGetEntityItem } from '@rexlabs/entity-normalizer';
import useModelActions from './use-model-actions';
import { containsAllFields } from '../utils/queries';
var consumerCounter = 0;
var empty = {};

function useEntity(_ref) {
  var model = _ref.model,
      id = _ref.id,
      _ref$args = _ref.args,
      args = _ref$args === void 0 ? empty : _ref$args,
      fields = _ref.fields,
      _ref$fetch = _ref.fetch,
      fetch = _ref$fetch === void 0 ? true : _ref$fetch;
  var actions = useModelActions(model);
  var consumerUuid = useMemo(function () {
    return "entity".concat(++consumerCounter);
  }, []);
  var data = useSelector(function (state) {
    return model !== null && model !== void 0 && model.modelName ? memGetEntityItem(state, model.modelName, id, fields) : empty;
  }); // HACK: for whatever reason the args reference when using `query` changes here,
  // so until we fix that we're taking the comparibly small panilty of running
  // JSON.stringify of a small object on every render :/

  var memoArgs = _JSON$stringify(args);

  var needsToFetch = useMemo(function () {
    return fetch && (!fields || !containsAllFields(data === null || data === void 0 ? void 0 : data.data, fields));
  }, // eslint-disable-next-line
  [memoArgs, fetch, data === null || data === void 0 ? void 0 : data.args]); // HACK: on initial render, if we know that the `useEffect` will fetch, we want
  // to set the initial status to `loading`, even if the data is currently loaded
  // This might happen e.g. when the args are different

  var isFetching = useRef(needsToFetch);
  var isReallyFetching = isFetching.current;
  isFetching.current = false;
  useEffect(function () {
    if (!fetch) {
      return;
    }

    if (!(actions !== null && actions !== void 0 && actions.fetchItem)) {
      return;
    }

    if (needsToFetch) {
      actions.fetchItem({
        id: id,
        uuid: consumerUuid,
        args: args
      }).catch(function (e) {
        if (__DEV__) {
          console.error('Caught error in `useEntity` initial load! This error will NOT ' + 'be forwarded, so if you want it to be thrown you will need to ' + 'either throw it manually in your API client or in your component ' + 'using `errors[x].originalError`.');
          console.error(e);
        }
      });
    } else {
      actions.registerConsumer({
        id: id,
        uuid: consumerUuid
      });
    } // Unregister on unmount or when the id or args change


    return function () {
      return actions.unregisterConsumer({
        uuid: consumerUuid
      });
    };
  }, // eslint-disable-next-line
  [fetch, id, memoArgs]);
  return useMemo(function () {
    return {
      consumer: consumerUuid,
      actions: actions,
      status: isReallyFetching ? 'loading' : data !== null && data !== void 0 && data.status ? data === null || data === void 0 ? void 0 : data.status : fetch ? 'loading' : null,
      data: (data === null || data === void 0 ? void 0 : data.data) || null,
      errors: data === null || data === void 0 ? void 0 : data.errors
    };
  }, // eslint-disable-next-line
  [consumerUuid, actions, data]);
}

export default useEntity;